<template>
  <div>
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="create"
      title="NOVA FORMA DE PAGAMENTO"
    >
      <Create @success="paginate" />
    </b-modal>
    <div class="row">
      <div class="col-md-8 border">
        <div class="row">
          <div
            class="
              col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12
              pr-0
              d-flex
              align-items-center
            "
          >
            <h1 class="title-pages">FORMAS DE PAGAMENTO</h1>
          </div>
          <div
            class="
              col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12
              pl-0
              text-right
              pl-0
            "
          >
            <v-btn
              v-if="permission('write', 'financial_payment_methods')"
              @click="$bvModal.show('create')"
              class="btn-add m-1"
              ><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR</v-btn
            >
          </div>
        </div>
        <div v-show="data.length > 0">
          <div class="row">
            <div class="col-md-12">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Pesquisar..."
                  @input="filter($event.target.value)"
                />
                <div
                  class="
                    input-group-pprend
                    d-flex
                    align-items-center
                    justify-content-center
                  "
                >
                  <v-btn disabled><i class="fas fa-search" /></v-btn>
                </div>
              </div>
            </div>
            <div class="col-md-8"><span class="ml-2">Nome</span></div>
            <div class="col-md-2">Status</div>
            <div class="col-md-2">Ação</div>
          </div>
        </div>
        <b-overlay :show="loading" opacity="0.99">
          <div class="v-clean p-5 text-center" v-show="data.length == 0">
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <div v-for="item in filtered" :key="item.id">
            <hr class="m-0" />
            <div class="row">
              <div class="col-md-8 d-flex align-items-center">
                <span class="ml-2">{{ item.description }}</span>
              </div>
              <div class="col-md-2 d-flex align-items-center">
                <span>
                  <i :class="[
                    'fas fa-circle',
                    item.status == 1 ? 'color-green' : 'color-warning',
                  ]"></i>
                  {{ item.status == 1 ? "ATIVO" : "INATIVO" }}</span>
              </div>
              <div class="col-md-2 d-flex align-items-center">
                <b-modal
                  size="md"
                  no-close-on-backdrop
                  hide-footer
                  :id="`edit-${item.id}`"
                  :title="`EDITAR FORMA DE PAGAMENTO: ${item.description}`"
                >
                  <Edit @success="paginate" :data="item" />
                </b-modal>
                <v-btn
                  v-if="permission('edit', 'financial_payment_methods')"
                  x-small
                  class="v-primary float-right"
                  @click="edit(item)"
                  >EDITAR</v-btn
                >
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
      <div class="col-md-4">
        <h6>O que é forma de pagamento?</h6>
        <p class="worksansr">
          A forma de pagamento representa a maneira como você pagou ou recebeu
          algum valor para ou de alguém. Exemplo: Dinheiro, Cheque, Cartão de
          Crédito, Boleto, etc.
        </p>
        <p class="worksansr">
          Também é possível controlar o tipo deste pagamento.
        </p>
        <p class="worksansr">
          Exemplo: <b>Cartão de Crédito Visa 0123</b>,
          <b>Cartão de Crédito Visa 0345</b>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Create from "./PaymentMethods/Create";

import Edit from "./PaymentMethods/Edit";

import api from "../../../services/api";

import permission from "../../../lib/permission";

export default {
  name: "PaymentMethods",
  components: {
    Create,
    Edit,
  },
  data() {
    return {
      data: [],
      filtered: [],
      loading: false,
    };
  },
  created() {
    this.paginate();
  },
  methods: {
    permission,

    filter(text) {
      let { data } = this;

      let filtered = data.filter(
        ({ description }) =>
          String(description)
            .toLowerCase()
            .indexOf(String(text).toLowerCase()) > -1
      );

      this.filtered = filtered;
    },
    async paginate() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/financial/configuration/payment-methods"
        );

        const { data } = response.data;

        this.data = data;
        this.filtered = data;

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    edit(parent) {
      this.$bvModal.show(`edit-${parent.id}`);
    },
  },
};
</script>


